module.exports = __webpack_public_path__ + "img/footer-bg.9c3d36a6.png";